import { useCallback, useEffect, useState } from "react";
import { getPlan } from "./api";
import { useLms } from "./LmsShell";

/**
 * Every course the student is in, each with its plan, for the pages that look across courses
 * (Grades, Projects). Active courses come first. `plans` is null while loading.
 */
export default function useCoursePlans() {
  const { overview, overviewError } = useLms();
  const [plans, setPlans] = useState(null);
  const [failed, setFailed] = useState(false);

  const load = useCallback(() => {
    if (!overview) return;
    const order = { active: 0, certificate_in_progress: 1, completed: 2 };
    const courses = [...(overview.courses || [])].sort((a, b) => (order[a.status] ?? 3) - (order[b.status] ?? 3));
    Promise.allSettled(courses.map((c) => getPlan(c.course.uuid, c.cohort.id))).then((results) => {
      const ok = results.map((r, i) => (r.status === "fulfilled" ? { ...courses[i], plan: r.value } : null)).filter(Boolean);
      setFailed(courses.length > 0 && ok.length === 0);
      setPlans(ok);
    });
  }, [overview]);

  useEffect(() => { load(); }, [load]);

  return { plans, failed: failed || overviewError, reload: load };
}
